import { render, staticRenderFns } from "./Cliente_picking_y_packing.vue?vue&type=template&id=35612ad6&scoped=true&"
import script from "./Cliente_picking_y_packing.vue?vue&type=script&lang=js&"
export * from "./Cliente_picking_y_packing.vue?vue&type=script&lang=js&"
import style0 from "./Cliente_picking_y_packing.vue?vue&type=style&index=0&id=35612ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35612ad6",
  null
  
)

export default component.exports